'use strict';

var App = require('app');
var Alarm = require('utils/alarm');
var AppState = require('app_state');
var Consts = require('consts');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var OOP = require('utils/oop');
var ColorConfig = require('components/devices/views/common/configure_chart_dialog_view');

var tempUtil = Misc.templateSet(require('components/devices/templates/alarm/alarm_list'));

var viewTemplates = {
    true: require('components/devices/templates/alarm/alarm_occurrence_xs'),
    false: require('components/devices/templates/alarm/alarm_occurrence'),
};

var thrUpdateStatus = Misc.throttle(function () {
    App.request('devices:status:update');
}, 5000);

module.exports = OOP.extend(
    Marionette.ItemView,
    {
        template: viewTemplates[true],
        events: OOP.inheritedObj('events', {
            'change input.js-alarm-select-all': function (e) {
                this.toggleSelectAll($(e.currentTarget).prop('checked'));
            },
            'change input.js-alarm-select': function (e) {
                this.saveSelected();
            },
            'click .js-alarm-sel-acknowledge': function (e) {
                this.updateSelected({ action: 'ack' });
            },
            'click .js-alarm-acknowledge': function (e) {
                this.ackAlarmRow(e);
            },
        }),

        ackAlarmRow: function (e) {
            var self = this;
            var $chk = $(e.currentTarget).closest('.js-alarm-item').find('.js-alarm-select');
            var idx = $chk.attr('data-occurence-idx');
            var model = this.options.data.items.models[idx];
            $.when(App.request('alarm-occurrences:update', { list: [model.id], fields: { action: 'ack' } })).done(
                function (x) {
                    model.set('is_acknowledged', true);
                    App.request('devices:status:update');
                    if (self.options.refreshCallback) {
                        self.options.refreshCallback();
                        return;
                    }
                    self.render();
                }
            );
        },

        updateSelected: function (act) {
            var self = this;
            $.when(
                App.request('alarm-occurrences:update', {
                    list: _.map(_.values(this.options.data.items.selected), function (x) {
                        return x.id;
                    }),
                    fields: act,
                })
            ).done(function (r) {
                if (!r) {
                    Notification.show(
                        'error',
                        i18n.TR('Fehler'),
                        i18n.TR('Die Alarme konnten nicht aktualisiert werden.')
                    );
                    return;
                }

                App.request('devices:status:update');
                if (self.options.refreshCallback) {
                    self.options.refreshCallback();
                    return;
                }
                self.setPage(self.paginationCtx.currentPage);
            });
        },

        toggleSelectAll: function (newStatus) {
            this.$el.find('.js-alarm-select').prop('checked', newStatus);
            this.saveSelected();
        },

        saveSelected: function () {
            var self = this;
            var allOn = true;
            var $chks = this.$el.find('input.js-alarm-select');
            var isSelected = false;
            var canAck = true; // all of selected alarms can be ack-ed. (=are not acked)

            _.each($chks, function (chk) {
                var $chk = $(chk);
                var idx = $chk.attr('data-occurence-idx');
                var item = self.options.data.items.models[idx];

                if ($chk.prop('checked')) {
                    item.select();
                    isSelected = true;

                    var isAck = item.get('is_acknowledged');
                    canAck = canAck && !isAck;
                } else {
                    allOn = false;
                    item.deselect();
                }
            });

            this.$el.find('input.js-alarm-select-all').prop('checked', allOn && $chks.length);
            this.$el.find('.js-alarm-sel-acknowledge').prop('disabled', !canAck || !isSelected);
        },

        initialize: function (data) {
            this.base.initialize(data);
            this.controller = data.controller;
            this.groupData = data.grpLink;
            this.template = viewTemplates[!!data.isSmall];
            this.refreshPagination(true);
        },

        refreshPagination: function (refreshCtx, startPage) {
            if (refreshCtx) {
                this.paginationCtx = {
                    currentPage: startPage || 1,
                    pageCount: Math.ceil(this.options.data.count / AppState.getItemsPerPage()),
                    totalCount: this.options.data.count,
                    itemsPerPage: AppState.getItemsPerPage(),
                    context: this,
                    onGotoPage: function (page) {
                        this.setPage(page);
                    },
                    onSetItemsPerPage: function (ipp) {
                        this.setItemsPerPage(ipp);
                    },
                };
            }
            this.pagination = Misc.generatePagination(this.paginationCtx);
        },

        setItemsPerPage: function (ipp) {
            AppState.saveItemsPerPage(ipp);
            this.refreshPagination(true);
            this.setPage(this.paginationCtx.currentPage);
        },

        setPage: function (page) {
            var offset = (page - 1) * AppState.getItemsPerPage();
            var self = this;
            $.when(this.options.data.gotoPage(offset, AppState.getItemsPerPage())).done(function (data) {
                self.options.data = data;
                self.paginationCtx.currentPage = page;
                self.refreshPagination(true, self.paginationCtx.currentPage);
                self.render();
            });
        },

        serializeData: function () {
            var self = this;

            return {
                alarm_name_visible: this.options.group != 'Name' || this.options.mixed,
                device_name_visible: this.options.group != 'Device' || this.options.mixed,
                priority_text_visible: this.options.group != 'Prio',

                pagination: this.pagination.html,
                items: _.map(this.options.data.items.toJSON(), function (item, idx) {
                    var item = self.getItem(item);
                    item.selected = self.options.data.items.models[idx].selected;
                    return item;
                }),
            };
        },

        getItem: function (item) {
            var self = this;
            return {
                alarm_name: item.alarm_name,
                device_name: item.device_name,
                device_status: item.device_status,
                device_link: Misc.getDeviceURL(item.device_category, item.device_id),
                cond_text: tempUtil.condition(
                    _.map(item.condition_values, function (row) {
                        return self.getCondItem(row, item);
                    })
                ),
                triggered_time: item.triggered_time,
                corrected_time: item.corrected_time,
                priority: Alarm.getPriorityText(item.priority),
                is_triggered: item.is_triggered,
                is_acknowledged: item.is_acknowledged,
                selected: item.selected,
                can_see_device: item.can_see_device,
                is_active: item.is_active,
                is_email: Date.parse(item.email_sent_at) > 0,
                is_sms: Date.parse(item.sms_sent_at) > 0,
                link: this.getOccurrenceLink(item),
            };
        },

        getOccurrenceLink: function (alarm) {
            var baseLink =
                Consts.DeviceCategory[alarm.device_category].url + '/' + alarm.device_id + '/analyze-predefined?';
            var analyzeConfig = Misc.getQuickAnalyzePeriod(alarm.triggered_time, alarm.corrected_time, 20 * 60 * 1000);

            // chart content
            analyzeConfig += '&chart_content={"advanced_mode":false,"invalid":false,"lines":[';

            // .. get colors from charting config dialog view
            var palette = new ColorConfig().defaultColors;
            var nr = 0;
            var referenced = [];

            // .. append the first 8 referenced data points
            _.each(alarm.condition_values, function (e) {
                var add = function (id, name) {
                    // device status referenced -> show events
                    if (id == 'STATUS') {
                        baseLink += 'show_events=true';
                        return;
                    }

                    // too many or undefined? -> skip
                    if (nr == 8 || id === undefined || id == '') {
                        return;
                    }
                    // already assigned? -> skip
                    if (_.indexOf(referenced, id) != -1) {
                        return;
                    }

                    // configure entry
                    if (nr != 0) {
                        analyzeConfig += ',';
                    }
                    analyzeConfig +=
                        '{"id":"' +
                        id +
                        '","name":"' +
                        name +
                        '","color":"' +
                        palette[nr] +
                        '","device":0,"label":"","field2":"","op":"","display":{"aggregation":"MEAN","timewindow":1,"type":0,"difference":0,"valid":true}}';

                    // update configuration state
                    nr += 1;
                    referenced.push(id);
                };

                add(e.line1, e.line1_name);
                add(e.line2, e.line2_name);
            });

            analyzeConfig += ']}';

            return baseLink + analyzeConfig;
        },

        getCondItem: function (item, alarm) {
            return Alarm.getConditionText(item, true, alarm);
        },

        onRender: function () {
            var self = this;
            setTimeout(function () {
                self.pagination.initEvents();
            });
            this.saveSelected();
            thrUpdateStatus();
        },

        onShow: function () {
            var self = this;
            setTimeout(function () {
                self.pagination.initEvents();
            });
            this.saveSelected();
        },
        onAttach: function () {
            var self = this;
            setTimeout(function () {
                self.pagination.initEvents();
            });
        },
    },
    'AlarmOccurrenceView'
);
